import { createSlice } from "@reduxjs/toolkit";

const initialState = { enableChild: false }
const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        setEnableChild(state, { payload }) {
            state.enableChild = payload
        }
    }
})

export default commonSlice.reducer;
export const commonActions = commonSlice.actions;